    <template>

    <div class="scrolldown">
        <FaIcon name="chevron-down" />
    </div>

</template>

<script>
    import FaIcon from "./FaIcon";
    import Arrow from "./Arrow";

    export default {
        name: 'Scrolldown',
        components: {FaIcon, Arrow},
        props: [],
    };
</script>

<style scoped lang="scss">

    @keyframes bounce {
        0% {transform: translateY(0) scale(1.8);}
        10% {transform: translateY(-5px) scale(1.8);}
        20% {transform: translateY(5px) scale(1.8);}
        30% {transform: translateY(-5px) scale(1.8);}
        40% {transform: translateY(5px) scale(1.8);}
        50% {transform: translateY(0) scale(1.8);}
    }

    .scrolldown{
        position: absolute;
        bottom: $G-default/3;
        left: 50%;
        z-index: $ZI-scrolldown;
        padding: $G-default/3 2*$G-default/3;
        color: #000;
        cursor: pointer;

        .fal{
            transform: translateY(0) scale(1.8);
            @include transition();
            animation: bounce 1.5s ease-in-out infinite alternate;
        }
    }
</style>